export default {

    indexOfferItemEmphasis:     { method: 'get',    url: 'offer_item_emphasis' },
    storeOfferItemEmphasis:     { method: 'post',   url: 'offer_item_emphasis' },
    updateOfferItemEmphasis:    { method: 'put',    url: 'offer_item_emphasis/{id}'},
    destroyOfferItemEmphasis:   { method: 'delete', url: 'offer_item_emphasis/{id}'},

}